import SendMoney from 'features/v2a/sender/screens/SendMoney/SendMoney';
import React from 'react';

export default function Page() {
  return <SendMoney />;
}
